import { ChangeDetectorRef, Component, EventEmitter, Input, NgZone, OnInit, Output } from '@angular/core';
import { Lightbox } from 'ngx-lightbox';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-anexos',
  templateUrl: './anexos.component.html',
  styleUrls: ['./anexos.component.scss'],
})
export class AnexosComponent implements OnInit {

  @Input() corPrimaria: string;
  @Input() imagens: Array<any> = [];
  @Input() pdfs: Array<any> = [];
  @Input() limite = 2;
  @Input() text = 'Insira arquivos PDF ou PNG que evidencie seus testes no ambiente de homologação para análise do DATASUS, conforme orientação no manual de integração. (Tamanho máximo 5MB).';
  @Output() fileSelected = new EventEmitter();
  @Output() fileExcluded = new EventEmitter();
  pdfSelecionado: any;
  showDetalhePddf: boolean;
  showAlert: boolean;

  constructor(
    private lightbox: Lightbox,
    private zone: NgZone,
    private cd: ChangeDetectorRef,
    private toast: ToastrService
  ) {}

  ngOnInit() {}

  async excluirAnexo(index: number, isImagem: boolean) {
    this.zone.run(() => {
      if (isImagem) {
        this.fileExcluded.emit({idArquivo: this.imagens[index].id, isImagem, index});
      } else {
        this.fileExcluded.emit({idArquivo: this.pdfs[index].id, isImagem, index});
      }
    });
  }

  abrirUpload() {
    const upload = document.getElementById('anexo') as HTMLInputElement;
    const form: any = document.getElementById('xform') as HTMLInputElement;
    upload.click();
    upload.onchange = async () => {
      if (upload.files) {
        const file = upload.files[0];
        if (file.size >= 5000000) {
          this.toast.error('O arquivo ultrapassa o tamanho de 5MB');
          return;
        } else if (file.type !== 'image/png' && file.type !== 'application/pdf') {
          this.toast.error('Formato de arquivo não suportado');
          return;
        }

        if ((this.pdfs.length + this.imagens.length) <= (this.limite-1)) {
          const formData = new FormData(form);
          if (file.type === 'application/pdf') {
            const arquivo = { src: await this.getBase64(file), tamanho: file.size, nome: file.name };
            this.fileSelected.emit({formData, arquivo, isImagem: false});
            this.cd.detectChanges();
          } else {
            const arquivo = { src: await this.getBase64(file), thumb: await this.getBase64(file), nome: file.name };
            this.fileSelected.emit({formData, arquivo, isImagem: true});
            this.cd.detectChanges();
          }
        } else {
          this.toast.error('Limite de '+this.limite+' arquivos');
        }
      }
    };
  }

  openLightbox(index: number): void {
    this.lightbox.open(this.imagens, index, {centerVertically: true});
  }

  async openPdf(pdf: any) {
    this.pdfSelecionado = pdf;
    this.showDetalhePddf = true;
  }

  fecharDetalhePdf() {
    this.showDetalhePddf = false;
  }

  private getBase64(file): Promise<any> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/anexos/anexos.component.ts